import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wave",
  "use": "icon-wave-usage",
  "viewBox": "0 0 1200 136",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1200 136\" id=\"icon-wave\">\r\n  <g transform=\"matrix(1 0 0 1 0 -608 )\">\r\n    <path d=\"M 980 0  C 1065.36894824708 0  1148.77598872025 30.6608428594283  1200 46  L 1200 135  L 0 135  L 0 136  L 0.977821935988542 135.788233430668  C 0.38533060023565 126.634555452302  49.8122592302581 74.9833308244099  193.322203672788 70  C 423.706176961603 62  473.869443699515 105.048536167675  613.021702838063 84  C 679.131886477462 74  894.631051752922 0  980 0  Z \" fill-rule=\"nonzero\" fill=\"#ffffff\" stroke=\"none\" transform=\"matrix(1 0 0 1 0 608 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/wave.svg
// module id = bUWB
// module chunks = 0